import {styled} from '@mui/material'
import Button from 'components/Control/Button'
import {useGetPaymentUrlMutation, useI18n} from 'store/Store'
import EditPaymentType from './EditPaymentType'
import analyticsService from 'services/analytic'

const PaymentTypes = ({item: user, isMobile}) => {
    const {i18n} = useI18n()

    // const [editCreditCard, setEditCreditCard] = useState(false)
    // const [doSaveCreditCard, {error, data: saveResponse}] =
    //     useSaveCreditCardMutation()

    const [doGetPaymentUrl, {data: paymentUrl, error: paymentUrlError}] =
        useGetPaymentUrlMutation()

    console.log('payment url', {
        paymentUrl,
        paymentUrlError,
        user,
    })

    const toggleEditCreditCard = async () => {
        const {data: getPaymentUrlRes} = await doGetPaymentUrl()
        console.log('get payment url res', getPaymentUrlRes)
        if (getPaymentUrlRes?.url) {
            window.location.href = getPaymentUrlRes?.url
        }
        // setEditCreditCard(!editCreditCard)
    }

    // const methods = useForm({
    //     mode: 'all',
    //     resolver: yupResolver(creditCardSchema),
    // })

    // const {handleSubmit} = methods

    // const onSubmit = (values) => {
    //     doSaveCreditCard(values)
    //     toggleEditCreditCard()
    // }

    // const submit = handleSubmit(onSubmit)

    // useEffect(() => {
    //     if (error) {
    //         window.alert(error?.data?.message || 'פעולה נכשלה')
    //     }
    //     if (saveResponse) {
    //         window.alert('פעולה בוצעה בהצלחה')
    //     }
    // }, [saveResponse, error])

    if (user.plannerMaskedPan) {
        // && !editCreditCard) {
        return (
            <EditPaymentType
                user={user}
                toggleEditCreditCard={() => {
                    toggleEditCreditCard()
                    analyticsService.paymentSettingsPressed(
                        'change_payment_method'
                    )
                }}
            />
        )
    }

    return (
        <Container isMobile={isMobile}>
            {/* {editCreditCard ? (
                <FormProvider {...methods}>
                    <CreditCardForm submit={submit} />
                </FormProvider>
            ) : ( */}
            <AddButtonWrapper>
                <AddButton
                    onClick={() => {
                        toggleEditCreditCard()
                        analyticsService.paymentSettingsPressed(
                            'add_payment_method'
                        )
                    }}>
                    {i18n.t('settings.addCreditCardButton')}
                </AddButton>
            </AddButtonWrapper>
            {/* )} */}
        </Container>
    )
}

export default PaymentTypes

const Container = styled('div')`
    width: 100%;
    height: ${({isMobile}) => (isMobile ? 'auto' : '100%')};
    background: #cbddee33;
    padding: 24px;
    display: flex;
`

const AddButtonWrapper = styled('div')`
    display: flex;
    justify-content: center;
    width: 100%;
`

const AddButton = styled(Button)``
